import React from 'react';
import { FunctionComponent } from 'react';
import ImageIcon from '@xFrame4/components/common/ImageIcon';

interface CtaArrowIconProps
{
    size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
    href?: string;
    /** Dark is default */
    variant?: 'dark' | 'light' | 'light-filled'
    onClick?: () => void;
}

const CtaArrowIcon: FunctionComponent<CtaArrowIconProps> = (props) =>
{
    let iconBaseSource = '_dope/ts/build/img/';
    
    /** Icon source */
    let src = 'cta-arrow.svg';
    if (props.variant === 'light')
    {
        src = 'cta-arrow-light.svg';
    }
    else if (props.variant === 'light-filled')
    {
        src = 'cta-arrow-light-filled.svg';
    }
    src = iconBaseSource + src;
    
    /** Component */
    let cmp =
        <ImageIcon
            src={src}
            size={props.size}
            className="cta-arrow-icon"
            onClick={props.onClick}
        />;
    
    if (props.href !== undefined)
    {
        cmp = 
        <a href={props.href}>
            {cmp}
        </a>
    }

    /** Render */
    return cmp;
}

export default CtaArrowIcon;